import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import "../../assets/css/agent/user-calls.scss";
import FeaturesTab from "../../components/FeaturesTab";
import RightBar from "../../components/RightBar";
import { AiOutlineReload } from "react-icons/ai";
import axiosInstance from "../../environment/axiosInstance";
import ReactPaginate from 'react-paginate';
import "../../assets/css/pagination.scss";

function UserCalls(props) {
    const { userId } = useParams();
    const history = useHistory();
    const [calls, setCalls] = useState([]);
    const [callsCount, setCallsCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);

    const useQuery = () => {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let searchParams = useQuery();

    useEffect(() => {
        let page = 1;

        if (searchParams.get("page")) {
            page = searchParams.get("page");
        }

        setPage(page);
        fetchCalls(page);
    }, [searchParams.get("page")]);

    const fetchCalls = (page) => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/call/customer/" + userId + "?page=" + page)
            .then(response => {
                if (response.data) {
                    console.log("calls ", response.data.Data.docs);
                    response.data.Data.docs.forEach(ticket => {
                        ticket.statusDropdownIsOpen = false;
                    });
                    setCalls(response.data.Data.docs);
                    setCallsCount(response.data.Data.totalDocs);
                    setTotalPages(response.data.Data.totalPages);
                }
            });
    }

    const handlePageClick = (event) => {
        history.push("/calls/" + userId + "?page=" + (event.selected + 1));
    }

    return (
        <div>
            {/* <Header />
            <UsersTabs /> */}
            <div className="user-calls row m-0">
                {/* <div
                    className="p-0 left-col"
                    style={{
                        borderRight: "1px solid #D9D9D9"
                    }}
                >
                    <LeftBar />
                </div> */}
                <div className="p-0 center-col">
                    <FeaturesTab />
                    <div className="calls-content">
                        <div className="top-bar">
                            <select name="type" className="form-control type-input">
                                <option value="missed">Missed Calls</option>
                                <option value="hangup">Hangup Calls</option>
                            </select>
                            <AiOutlineReload
                                size={20}
                                color="#999999"
                                className="ms-2 cursor-pointer"
                            />
                        </div>
                        <div className="calls-section">
                            {
                                calls?.map(call => {
                                    return (
                                        <div className="mt-4 call-card d-flex align-items-center justify-content-between">
                                            <div>
                                                <p className="m-0 user-name">{call.customer?.customer_name}</p>
                                                <p className="m-0 contact">+971553876578</p>
                                            </div>
                                            <p className={
                                                "m-0 call-type " + (
                                                    call.status == "declined" ?
                                                        "missed-call"
                                                        :
                                                        "hangup-call"
                                                )
                                            }>{call.status}</p>
                                            <p className="m-0 date">
                                                Ticket Id: {call.ticket_id?.ticket_id}
                                            </p>
                                            <div className="m-0 date">
                                                <p className="m-0">{call.createdAt.split("T")[0]}</p>
                                                <p className="m-0">{call.createdAt.split("T")[1]}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel=">"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={totalPages}
                                previousLabel="<"
                                renderOnZeroPageCount={null}
                                className="pagination"
                                activeClassName="active-page"
                                forcePage={page - 1}
                            />
                        </div>
                    </div>
                </div>
                <div
                    className="p-0 right-col"
                    style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}
                >
                    <RightBar />
                </div>
            </div>
        </div >
    )
}

export default UserCalls;